module.exports = __webpack_public_path__ + "img/bere.b20666f0.png";